<script lang="ts">
    import { onMount } from 'svelte';

    import { globalToastMessage } from '../store/index';

    import Toast from './Toast.svelte';

    let toastRef: Toast;

    onMount(() => {
        const unsub = globalToastMessage.subscribe((msg) => {
            if (!msg) return;

            globalToastMessage.set(null);
            toastRef?.show(msg);
        });

        return unsub;
    });
</script>

<Toast bind:this={toastRef} />
